<template>
  <span
    :style="{ fontSize: `${size}em` }"
    class="busy"
  >
    <span class="busy__dot"/>
    <span class="busy__dot"/>
    <span class="busy__dot"/>
  </span>
</template>

<script>
export default {
  name: 'CBusy',

  props: {
    size: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style scoped>
.busy {
  display: inline-flex;
  vertical-align: top;
}

.busy__dot {
  width: 0.5em;
  height: 0.5em;
  transform: scale(0.3);

  background-color: currentColor;
  border-radius: 50%;

  animation: bubble 1s linear infinite;
}

.busy__dot:nth-child(2) {
  animation-delay: 250ms;
}

.busy__dot:nth-child(3) {
  animation-delay: 500ms;
}

@keyframes bubble {
  0% {
    transform: scale(0.3);
  }

  50% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.3);
  }
}
</style>
